<script setup lang="ts">
  import { computed } from 'vue';
  // Icons
  import DocumentIcon from '@/shared/assets/icons/DocumentIcon.svg';
  import ModelsIcon from '@/shared/assets/icons/ModelsIcon.svg';
  import ConfigsIcon from '@/shared/assets/icons/ConfigsIcon.svg';
  // Components
  import { TabsMenu } from '@/shared/ui';
  import { useRouter } from 'vue-router';

  const router = useRouter();
  const currentRoute = computed(() => router.currentRoute.value.path);

  const MODULE_SEGMENT = 'gestao-registros';
  const DEFAULT_TAB = 'lista-registros';

  const OPTIONS = [
    {
      id: 'lista-registros',
      text: 'Lista de Registros',
      icon: DocumentIcon,
    },
    {
      id: 'modelos',
      text: 'Modelos',
      icon: ModelsIcon,
    },
    {
      id: 'ajustar-configuracoes',
      text: 'Configurações',
      icon: ConfigsIcon,
    },
  ];

  const selectedOption = computed(() => {
    const segments = currentRoute.value.split('/').filter((segment) => segment.length > 0);
    const lastSegment = segments[segments.length - 1];

    if (!lastSegment || lastSegment === MODULE_SEGMENT) return DEFAULT_TAB;

    return lastSegment;
  });

  const handleOptionSelect = (optionId: string) => {
    router.push(`/${MODULE_SEGMENT}/${optionId}`);
  };
</script>

<template>
  <div class="pt-4 p-6">
    <h3 class="text-gray-07 text-xl/7.5 font-semibold text-left mb-6">
      Gestão de Registros
    </h3>
    <TabsMenu
      :options="OPTIONS"
      :selected-option="selectedOption"
      class="mb-6"
      @option-selected="handleOptionSelect"
    />
    <router-view />
  </div>
</template>
